{
  "nsw-grey": {
    "50": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          98.039216
        ],
        "alpha": 1,
        "hex": "#fafafa"
      }
    },
    "100": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          96.078431
        ],
        "alpha": 1,
        "hex": "#f5f5f5"
      }
    },
    "150": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          94.117647
        ],
        "alpha": 1,
        "hex": "#f0f0f0"
      }
    },
    "200": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          92.156863
        ],
        "alpha": 1,
        "hex": "#ebebeb"
      }
    },
    "250": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          200,
          5.660377,
          89.607843
        ],
        "alpha": 1,
        "hex": "#e3e5e6"
      }
    },
    "300": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          195,
          6.060606,
          87.058824
        ],
        "alpha": 1,
        "hex": "#dcdfe0"
      }
    },
    "350": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          197.142857,
          8.860759,
          84.509804
        ],
        "alpha": 1,
        "hex": "#d4d9db"
      }
    },
    "400": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          200,
          9.89011,
          82.156863
        ],
        "alpha": 1,
        "hex": "#cdd3d6"
      }
    },
    "450": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          204,
          6.25,
          68.627451
        ],
        "alpha": 1,
        "hex": "#aab0b4"
      }
    },
    "500": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          198,
          4.385965,
          55.294118
        ],
        "alpha": 1,
        "hex": "#888f92"
      }
    },
    "550": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          198,
          4.587156,
          42.745098
        ],
        "alpha": 1,
        "hex": "#686f72"
      }
    },
    "600": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          201.818182,
          7.006369,
          30.784314
        ],
        "alpha": 1,
        "hex": "#495054"
      }
    },
    "650": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          204,
          7.352941,
          26.666667
        ],
        "alpha": 1,
        "hex": "#3f4549"
      }
    },
    "700": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          204,
          8.62069,
          22.745098
        ],
        "alpha": 1,
        "hex": "#353b3f"
      }
    },
    "750": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          204,
          10.416667,
          18.823529
        ],
        "alpha": 1,
        "hex": "#2b3135"
      }
    },
    "800": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          206.666667,
          11.688312,
          15.098039
        ],
        "alpha": 1,
        "hex": "#22272b"
      }
    },
    "850": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          205.714286,
          12.727273,
          10.784314
        ],
        "alpha": 1,
        "hex": "#181c1f"
      }
    },
    "900": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          204,
          15.151515,
          6.470588
        ],
        "alpha": 1,
        "hex": "#0e1113"
      }
    },
    "950": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          210,
          28.571429,
          2.745098
        ],
        "alpha": 1,
        "hex": "#050709"
      }
    }
  },
  "nsw-green": {
    "50": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          126,
          100,
          98.039216
        ],
        "alpha": 1,
        "hex": "#f5fff6"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          127.058824,
          80.952381,
          95.882353
        ],
        "alpha": 1,
        "hex": "#ecfdee"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          127.5,
          80,
          94.117647
        ],
        "alpha": 1,
        "hex": "#e4fce7"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 200: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          127.741935,
          75.609756,
          91.960784
        ],
        "alpha": 1,
        "hex": "#dbfadf"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 250: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          127.5,
          71.428571,
          89.019608
        ],
        "alpha": 1,
        "hex": "#cff7d4"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          128.4,
          69.444444,
          85.882353
        ],
        "alpha": 1,
        "hex": "#c2f4c9"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          129.152542,
          66.292135,
          82.54902
        ],
        "alpha": 1,
        "hex": "#b5f0be"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          129.565217,
          65.714286,
          79.411765
        ],
        "alpha": 1,
        "hex": "#a8edb3"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          130.243902,
          53.947368,
          70.196078
        ],
        "alpha": 1,
        "hex": "#8adc98"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          131.632653,
          49,
          60.784314
        ],
        "alpha": 1,
        "hex": "#6acc7d"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          134.745763,
          46.456693,
          50.196078
        ],
        "alpha": 1,
        "hex": "#45bb62"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          144.352941,
          100,
          33.333333
        ],
        "alpha": 1,
        "hex": "#00aa45"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          139.111111,
          90.604027,
          29.215686
        ],
        "alpha": 1,
        "hex": "#078e32"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 700: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          133.888889,
          88.52459,
          23.921569
        ],
        "alpha": 1,
        "hex": "#077320"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 750: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          128.372093,
          93.478261,
          18.039216
        ],
        "alpha": 1,
        "hex": "#03590f"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 800: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          120,
          100,
          12.54902
        ],
        "alpha": 1,
        "hex": "#004000"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          120,
          100,
          9.411765
        ],
        "alpha": 1,
        "hex": "#003000"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          120,
          100,
          6.27451
        ],
        "alpha": 1,
        "hex": "#002000"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          120,
          100,
          3.333333
        ],
        "alpha": 1,
        "hex": "#001100"
      }
    }
  },
  "nsw-teal": {
    "50": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          173.333333,
          52.941176,
          96.666667
        ],
        "alpha": 1,
        "hex": "#f2fbfa"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          172.5,
          50,
          93.72549
        ],
        "alpha": 1,
        "hex": "#e7f7f5"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          171.818182,
          45.833333,
          90.588235
        ],
        "alpha": 1,
        "hex": "#dcf2ef"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          171.724138,
          46.031746,
          87.647059
        ],
        "alpha": 1,
        "hex": "#d1eeea"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          175.609756,
          49.39759,
          83.72549
        ],
        "alpha": 1,
        "hex": "#c1eae7"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          180,
          50.943396,
          79.215686
        ],
        "alpha": 1,
        "hex": "#afe5e5"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          184.225352,
          57.723577,
          75.882353
        ],
        "alpha": 1,
        "hex": "#9ee0e5"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          186.741573,
          63.120567,
          72.352941
        ],
        "alpha": 1,
        "hex": "#8cdbe5"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          187.333333,
          48.387097,
          63.529412
        ],
        "alpha": 1,
        "hex": "#75c4cf"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          188.571429,
          39.393939,
          54.705882
        ],
        "alpha": 1,
        "hex": "#5eacb9"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          188.387097,
          39.914163,
          45.686275
        ],
        "alpha": 1,
        "hex": "#4696a3"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          188.75,
          51.06383,
          36.862745
        ],
        "alpha": 1,
        "hex": "#2e808e"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          188.372093,
          53.75,
          31.372549
        ],
        "alpha": 1,
        "hex": "#256f7b"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          187.792208,
          57.894737,
          26.078431
        ],
        "alpha": 1,
        "hex": "#1c5f69"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          188.823529,
          62.962963,
          21.176471
        ],
        "alpha": 1,
        "hex": "#144e58"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          188,
          73.170732,
          16.078431
        ],
        "alpha": 1,
        "hex": "#0b3f47"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          187.346939,
          85.964912,
          11.176471
        ],
        "alpha": 1,
        "hex": "#042f35"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          188.571429,
          94.594595,
          7.254902
        ],
        "alpha": 1,
        "hex": "#011f24"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          189,
          100,
          3.921569
        ],
        "alpha": 1,
        "hex": "#001114"
      }
    }
  },
  "nsw-blue": {
    "50": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          196,
          100,
          97.058824
        ],
        "alpha": 1,
        "hex": "#f0fbff"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          200,
          100,
          94.705882
        ],
        "alpha": 1,
        "hex": "#e4f6ff"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          198.461538,
          95.121951,
          91.960784
        ],
        "alpha": 1,
        "hex": "#d7f2fe"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          199.2,
          92.592593,
          89.411765
        ],
        "alpha": 1,
        "hex": "#cbedfd"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          198.181818,
          97.058824,
          86.666667
        ],
        "alpha": 1,
        "hex": "#bceafe"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          197.560976,
          100,
          83.921569
        ],
        "alpha": 1,
        "hex": "#ade7ff"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          197.142857,
          100,
          80.784314
        ],
        "alpha": 1,
        "hex": "#9de3ff"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          196.173913,
          100,
          77.45098
        ],
        "alpha": 1,
        "hex": "#8ce0ff"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          199.636364,
          100,
          67.647059
        ],
        "alpha": 1,
        "hex": "#5ac9ff"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          202.396313,
          100,
          57.45098
        ],
        "alpha": 1,
        "hex": "#26aeff"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          206.352941,
          100,
          50
        ],
        "alpha": 1,
        "hex": "#008fff"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          217.339056,
          98.312236,
          53.529412
        ],
        "alpha": 1,
        "hex": "#146cfd"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          216.6,
          89.285714,
          43.921569
        ],
        "alpha": 1,
        "hex": "#0c5ad4"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          216.071429,
          94.382022,
          34.901961
        ],
        "alpha": 1,
        "hex": "#0548ad"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          216.716418,
          97.101449,
          27.058824
        ],
        "alpha": 1,
        "hex": "#023688"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          217.2,
          100,
          19.607843
        ],
        "alpha": 1,
        "hex": "#002664"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          219.74026,
          100,
          15.098039
        ],
        "alpha": 1,
        "hex": "#001a4d"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          222.545455,
          100,
          10.784314
        ],
        "alpha": 1,
        "hex": "#001037"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          229.411765,
          100,
          6.666667
        ],
        "alpha": 1,
        "hex": "#000622"
      }
    }
  },
  "nsw-purple": {
    "50": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          255,
          100,
          98.431373
        ],
        "alpha": 1,
        "hex": "#f9f7ff"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          248,
          100,
          97.058824
        ],
        "alpha": 1,
        "hex": "#f2f0ff"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          250.909091,
          91.666667,
          95.294118
        ],
        "alpha": 1,
        "hex": "#ece8fe"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          250.714286,
          87.5,
          93.72549
        ],
        "alpha": 1,
        "hex": "#e6e1fd"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          251.351351,
          94.871795,
          92.352941
        ],
        "alpha": 1,
        "hex": "#e0d9fe"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          253.043478,
          95.833333,
          90.588235
        ],
        "alpha": 1,
        "hex": "#dad0fe"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          253.090909,
          100,
          89.215686
        ],
        "alpha": 1,
        "hex": "#d4c8ff"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          254.0625,
          100,
          87.45098
        ],
        "alpha": 1,
        "hex": "#cebfff"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          253.953488,
          93.478261,
          81.960784
        ],
        "alpha": 1,
        "hex": "#baa6fc"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          253.888889,
          90,
          76.470588
        ],
        "alpha": 1,
        "hex": "#a68df9"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          255.114504,
          86.754967,
          70.392157
        ],
        "alpha": 1,
        "hex": "#9372f5"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          256.538462,
          84.782609,
          63.921569
        ],
        "alpha": 1,
        "hex": "#8055f1"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          260.142857,
          59.322034,
          53.72549
        ],
        "alpha": 1,
        "hex": "#7243cf"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          264.193548,
          55.357143,
          43.921569
        ],
        "alpha": 1,
        "hex": "#6432ae"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          268.073394,
          62.285714,
          34.313725
        ],
        "alpha": 1,
        "hex": "#54218e"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          272.210526,
          73.643411,
          25.294118
        ],
        "alpha": 1,
        "hex": "#441170"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          273.076923,
          82.978723,
          18.431373
        ],
        "alpha": 1,
        "hex": "#330856"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          273,
          93.75,
          12.54902
        ],
        "alpha": 1,
        "hex": "#23023e"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          269.230769,
          100,
          7.647059
        ],
        "alpha": 1,
        "hex": "#130027"
      }
    }
  },
  "nsw-fuchsia": {
    "50": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          313.333333,
          100,
          98.235294
        ],
        "alpha": 1,
        "hex": "#fff6fd"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          321.176471,
          100,
          96.666667
        ],
        "alpha": 1,
        "hex": "#ffeef9"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          320,
          92.307692,
          94.901961
        ],
        "alpha": 1,
        "hex": "#fee6f6"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          321.290323,
          88.571429,
          93.137255
        ],
        "alpha": 1,
        "hex": "#fddef2"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          318.461538,
          82.978723,
          90.784314
        ],
        "alpha": 1,
        "hex": "#fbd4ef"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          317.5,
          80,
          88.235294
        ],
        "alpha": 1,
        "hex": "#f9c9eb"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          315,
          77.777778,
          85.882353
        ],
        "alpha": 1,
        "hex": "#f7bfe9"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          313.333333,
          74.117647,
          83.333333
        ],
        "alpha": 1,
        "hex": "#f4b5e6"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          314.157303,
          73.553719,
          76.27451
        ],
        "alpha": 1,
        "hex": "#ef96da"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          315,
          72.5,
          68.627451
        ],
        "alpha": 1,
        "hex": "#e975cc"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          314.482759,
          70.731707,
          59.803922
        ],
        "alpha": 1,
        "hex": "#e150be"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          312.964824,
          84.680851,
          46.078431
        ],
        "alpha": 1,
        "hex": "#d912ae"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          313.371429,
          87.939698,
          39.019608
        ],
        "alpha": 1,
        "hex": "#bb0c94"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          313.509934,
          92.638037,
          31.960784
        ],
        "alpha": 1,
        "hex": "#9d067b"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          313.700787,
          96.946565,
          25.686275
        ],
        "alpha": 1,
        "hex": "#810264"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          314.257426,
          100,
          19.803922
        ],
        "alpha": 1,
        "hex": "#65004d"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          314.805195,
          100,
          15.098039
        ],
        "alpha": 1,
        "hex": "#4d003a"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          316.363636,
          100,
          10.784314
        ],
        "alpha": 1,
        "hex": "#370028"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          319.411765,
          100,
          6.666667
        ],
        "alpha": 1,
        "hex": "#220017"
      }
    }
  },
  "nsw-red": {
    "50": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          351.428571,
          100,
          98.627451
        ],
        "alpha": 1,
        "hex": "#fff8f9"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          350.769231,
          100,
          97.45098
        ],
        "alpha": 1,
        "hex": "#fff2f4"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          350.526316,
          100,
          96.27451
        ],
        "alpha": 1,
        "hex": "#ffecef"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 200: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          350.4,
          100,
          95.098039
        ],
        "alpha": 1,
        "hex": "#ffe6ea"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 250: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          351.666667,
          100,
          92.941176
        ],
        "alpha": 1,
        "hex": "#ffdbe0"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          351.25,
          100,
          90.588235
        ],
        "alpha": 1,
        "hex": "#ffcfd6"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          351.864407,
          100,
          88.431373
        ],
        "alpha": 1,
        "hex": "#ffc4cc"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          352.394366,
          100,
          86.078431
        ],
        "alpha": 1,
        "hex": "#ffb8c1"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          353.195876,
          87.387387,
          78.235294
        ],
        "alpha": 1,
        "hex": "#f897a2"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          354.098361,
          79.220779,
          69.803922
        ],
        "alpha": 1,
        "hex": "#ef7581"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          353.557047,
          73.399015,
          60.196078
        ],
        "alpha": 1,
        "hex": "#e44f5f"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          348.556701,
          82.20339,
          46.27451
        ],
        "alpha": 1,
        "hex": "#d7153a"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          347.368421,
          85.929648,
          39.019608
        ],
        "alpha": 1,
        "hex": "#b90e32"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 700: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          345.810811,
          91.358025,
          31.764706
        ],
        "alpha": 1,
        "hex": "#9b072a"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 750: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          344.878049,
          95.348837,
          25.294118
        ],
        "alpha": 1,
        "hex": "#7e0322"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 800: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          344.848485,
          100,
          19.411765
        ],
        "alpha": 1,
        "hex": "#630019"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          347.368421,
          100,
          14.901961
        ],
        "alpha": 1,
        "hex": "#4c0010"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          351.111111,
          100,
          10.588235
        ],
        "alpha": 1,
        "hex": "#360008"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          354.545455,
          100,
          6.470588
        ],
        "alpha": 1,
        "hex": "#210003"
      }
    }
  },
  "nsw-orange": {
    "50": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          26.666667,
          100,
          98.235294
        ],
        "alpha": 1,
        "hex": "#fffaf6"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          28.235294,
          100,
          96.666667
        ],
        "alpha": 1,
        "hex": "#fff6ee"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          26.086957,
          92,
          95.098039
        ],
        "alpha": 1,
        "hex": "#fef1e7"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          28,
          88.235294,
          93.333333
        ],
        "alpha": 1,
        "hex": "#fdeddf"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          28.75,
          96,
          90.196078
        ],
        "alpha": 1,
        "hex": "#fee5ce"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          29.090909,
          100,
          87.058824
        ],
        "alpha": 1,
        "hex": "#ffddbd"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          30.714286,
          100,
          83.529412
        ],
        "alpha": 1,
        "hex": "#ffd6ab"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          31.176471,
          100,
          80
        ],
        "alpha": 1,
        "hex": "#ffce99"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          27.969925,
          97.080292,
          73.137255
        ],
        "alpha": 1,
        "hex": "#fdb678"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          25.398773,
          95.321637,
          66.470588
        ],
        "alpha": 1,
        "hex": "#fb9d58"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          22.736842,
          92.23301,
          59.607843
        ],
        "alpha": 1,
        "hex": "#f78139"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          20,
          90,
          52.941176
        ],
        "alpha": 1,
        "hex": "#f3631b"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          18.181818,
          82.5,
          47.058824
        ],
        "alpha": 1,
        "hex": "#db5115"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          16.243094,
          86.602871,
          40.980392
        ],
        "alpha": 1,
        "hex": "#c33f0e"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          14.545455,
          93.220339,
          34.705882
        ],
        "alpha": 1,
        "hex": "#ab2e06"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          10.945946,
          100,
          29.019608
        ],
        "alpha": 1,
        "hex": "#941b00"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          7.826087,
          100,
          22.54902
        ],
        "alpha": 1,
        "hex": "#730f00"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          2.891566,
          100,
          16.27451
        ],
        "alpha": 1,
        "hex": "#530400"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          0,
          100,
          10.392157
        ],
        "alpha": 1,
        "hex": "#350000"
      }
    }
  },
  "nsw-yellow": {
    "50": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          48,
          100,
          97.058824
        ],
        "alpha": 1,
        "hex": "#fffcf0"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          48.461538,
          100,
          94.901961
        ],
        "alpha": 1,
        "hex": "#fffae5"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          47.027027,
          100,
          92.745098
        ],
        "alpha": 1,
        "hex": "#fff7da"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 200: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          46.25,
          100,
          90.588235
        ],
        "alpha": 1,
        "hex": "#fff4cf"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 250: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          46.229508,
          100,
          88.039216
        ],
        "alpha": 1,
        "hex": "#fff1c2"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          46.849315,
          97.333333,
          85.294118
        ],
        "alpha": 1,
        "hex": "#feeeb5"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          46.046512,
          97.727273,
          82.745098
        ],
        "alpha": 1,
        "hex": "#feeaa8"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          46.666667,
          96.116505,
          79.803922
        ],
        "alpha": 1,
        "hex": "#fde79a"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          43.902439,
          93.89313,
          74.313725
        ],
        "alpha": 1,
        "hex": "#fbda80"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          42.119205,
          93.78882,
          68.431373
        ],
        "alpha": 1,
        "hex": "#facd63"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          40.434783,
          94.845361,
          61.960784
        ],
        "alpha": 1,
        "hex": "#fabe42"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          41.632653,
          96.078431,
          50
        ],
        "alpha": 1,
        "hex": "#faaf05"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          41.626794,
          97.209302,
          42.156863
        ],
        "alpha": 1,
        "hex": "#d49403"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 700: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          41.724138,
          98.863636,
          34.509804
        ],
        "alpha": 1,
        "hex": "#af7a01"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 750: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          41.438849,
          100,
          27.254902
        ],
        "alpha": 1,
        "hex": "#8b6000"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 800: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          41.142857,
          100,
          20.588235
        ],
        "alpha": 1,
        "hex": "#694800"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          39.75,
          100,
          15.686275
        ],
        "alpha": 1,
        "hex": "#503500"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          37.894737,
          100,
          11.176471
        ],
        "alpha": 1,
        "hex": "#392400"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          33.529412,
          100,
          6.666667
        ],
        "alpha": 1,
        "hex": "#221300"
      }
    }
  },
  "nsw-brown": {
    "50": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          34.285714,
          46.666667,
          97.058824
        ],
        "alpha": 1,
        "hex": "#fbf8f4"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          35,
          40,
          94.117647
        ],
        "alpha": 1,
        "hex": "#f6f1ea"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          31.764706,
          39.534884,
          91.568627
        ],
        "alpha": 1,
        "hex": "#f2eae1"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          32.727273,
          37.931034,
          88.627451
        ],
        "alpha": 1,
        "hex": "#ede3d7"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          32,
          44.117647,
          86.666667
        ],
        "alpha": 1,
        "hex": "#ecdece"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          33.333333,
          46.153846,
          84.705882
        ],
        "alpha": 1,
        "hex": "#eadac6"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          32.727273,
          50,
          82.745098
        ],
        "alpha": 1,
        "hex": "#e9d5bd"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          31.764706,
          52.57732,
          80.980392
        ],
        "alpha": 1,
        "hex": "#e8d0b5"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          32,
          45.454545,
          74.117647
        ],
        "alpha": 1,
        "hex": "#dbbf9f"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          31.714286,
          42.168675,
          67.45098
        ],
        "alpha": 1,
        "hex": "#cfae89"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          31.898734,
          39.303483,
          60.588235
        ],
        "alpha": 1,
        "hex": "#c29d73"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          32.359551,
          37.87234,
          53.921569
        ],
        "alpha": 1,
        "hex": "#b68d5d"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          31.851852,
          35.064935,
          45.294118
        ],
        "alpha": 1,
        "hex": "#9c764b"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          31.666667,
          38.297872,
          36.862745
        ],
        "alpha": 1,
        "hex": "#82603a"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          31.384615,
          44.217687,
          28.823529
        ],
        "alpha": 1,
        "hex": "#6a4b29"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          31.578947,
          53.271028,
          20.980392
        ],
        "alpha": 1,
        "hex": "#523719"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          31.914894,
          61.038961,
          15.098039
        ],
        "alpha": 1,
        "hex": "#3e280f"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          31.666667,
          72,
          9.803922
        ],
        "alpha": 1,
        "hex": "#2b1a07"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          28.695652,
          85.185185,
          5.294118
        ],
        "alpha": 1,
        "hex": "#190d02"
      }
    }
  },
  "nsw-aboriginal-grey": {
    "50": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          30,
          14.285714,
          97.254902
        ],
        "alpha": 1,
        "hex": "#f9f8f7"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          40,
          10.344828,
          94.313725
        ],
        "alpha": 1,
        "hex": "#f2f1ef"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          40,
          6.976744,
          91.568627
        ],
        "alpha": 1,
        "hex": "#ebeae8"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Smoke Grey. Step 200: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          36,
          8.77193,
          88.823529
        ],
        "alpha": 1,
        "hex": "#e5e3e0"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 250: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          34.285714,
          9.859155,
          86.078431
        ],
        "alpha": 1,
        "hex": "#dfdcd8"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          25.714286,
          8.235294,
          83.333333
        ],
        "alpha": 1,
        "hex": "#d8d4d1"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          26.666667,
          9.090909,
          80.588235
        ],
        "alpha": 1,
        "hex": "#d2cdc9"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Ash Grey. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          24,
          8.928571,
          78.039216
        ],
        "alpha": 1,
        "hex": "#ccc6c2"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 450: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          22.5,
          4.651163,
          66.27451
        ],
        "alpha": 1,
        "hex": "#ada8a5"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey — part of the NSW Government Aboriginal colour palette, which reflects the history of Aboriginal people within NSW, rich in diversity of culture, tribes, landscapes and history. Step 500: mid-tone.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          15,
          1.73913,
          54.901961
        ],
        "alpha": 1,
        "hex": "#8e8b8a"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 550: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          30,
          0.892857,
          43.921569
        ],
        "alpha": 1,
        "hex": "#71706f"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Emu Grey. Step 600: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          33.333333
        ],
        "alpha": 1,
        "hex": "#555555"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 650: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          28.627451
        ],
        "alpha": 1,
        "hex": "#494949"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 700: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          23.921569
        ],
        "alpha": 1,
        "hex": "#3d3d3d"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 750: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          19.607843
        ],
        "alpha": 1,
        "hex": "#323232"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Charcoal Grey. Step 800: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          15.294118
        ],
        "alpha": 1,
        "hex": "#272727"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          10.980392
        ],
        "alpha": 1,
        "hex": "#1c1c1c"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          6.666667
        ],
        "alpha": 1,
        "hex": "#111111"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          2.745098
        ],
        "alpha": 1,
        "hex": "#070707"
      }
    }
  },
  "nsw-aboriginal-red": {
    "50": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          0,
          100,
          98.039216
        ],
        "alpha": 1,
        "hex": "#fff5f5"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          0,
          100,
          96.078431
        ],
        "alpha": 1,
        "hex": "#ffebeb"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          0,
          93.333333,
          94.117647
        ],
        "alpha": 1,
        "hex": "#fee2e2"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Galah Pink. Step 200: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          0,
          90,
          92.156863
        ],
        "alpha": 1,
        "hex": "#fdd9d9"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 250: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          0,
          91.836735,
          90.392157
        ],
        "alpha": 1,
        "hex": "#fdd0d0"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          1.111111,
          90,
          88.235294
        ],
        "alpha": 1,
        "hex": "#fcc7c6"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          0,
          91.304348,
          86.470588
        ],
        "alpha": 1,
        "hex": "#fcbdbd"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Coral Pink. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          0.833333,
          90,
          84.313725
        ],
        "alpha": 1,
        "hex": "#fbb4b3"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 450: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          1.8,
          86.206897,
          77.254902
        ],
        "alpha": 1,
        "hex": "#f79693"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red — part of the NSW Government Aboriginal colour palette, which reflects the history of Aboriginal people within NSW, rich in diversity of culture, tribes, landscapes and history. Step 500: mid-tone.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          2.790698,
          83.225806,
          69.607843
        ],
        "alpha": 1,
        "hex": "#f27771"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 550: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          3.417722,
          79,
          60.784314
        ],
        "alpha": 1,
        "hex": "#ea554c"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Ember Red. Step 600: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          3.045685,
          77.865613,
          49.607843
        ],
        "alpha": 1,
        "hex": "#e1261c"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 650: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          2.637363,
          79.824561,
          44.705882
        ],
        "alpha": 1,
        "hex": "#cd1f17"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 700: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          2.485207,
          83.251232,
          39.803922
        ],
        "alpha": 1,
        "hex": "#ba1811"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 750: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          2.307692,
          87.640449,
          34.901961
        ],
        "alpha": 1,
        "hex": "#a7110b"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Earth Red. Step 800: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          1.258741,
          92.258065,
          30.392157
        ],
        "alpha": 1,
        "hex": "#950906"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          359.482759,
          100,
          22.745098
        ],
        "alpha": 1,
        "hex": "#740001"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          0,
          100,
          16.470588
        ],
        "alpha": 1,
        "hex": "#540000"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          0,
          100,
          10.588235
        ],
        "alpha": 1,
        "hex": "#360000"
      }
    }
  },
  "nsw-aboriginal-orange": {
    "50": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          25.263158,
          100,
          96.27451
        ],
        "alpha": 1,
        "hex": "#fff4ec"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          21.818182,
          94.285714,
          93.137255
        ],
        "alpha": 1,
        "hex": "#fee9dd"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          22.978723,
          88.679245,
          89.607843
        ],
        "alpha": 1,
        "hex": "#fcdfcd"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Sunset Orange. Step 200: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          22.372881,
          83.098592,
          86.078431
        ],
        "alpha": 1,
        "hex": "#f9d4be"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 250: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          22.702703,
          84.090909,
          82.745098
        ],
        "alpha": 1,
        "hex": "#f8caae"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          22.247191,
          84.761905,
          79.411765
        ],
        "alpha": 1,
        "hex": "#f7bf9e"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          22.5,
          85.245902,
          76.078431
        ],
        "alpha": 1,
        "hex": "#f6b58e"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Clay Orange. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          22.689076,
          84.397163,
          72.352941
        ],
        "alpha": 1,
        "hex": "#f4aa7d"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 450: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          22.12766,
          85.454545,
          67.647059
        ],
        "alpha": 1,
        "hex": "#f39a66"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange — part of the NSW Government Aboriginal colour palette, which reflects the history of Aboriginal people within NSW, rich in diversity of culture, tribes, landscapes and history. Step 500: mid-tone.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          21.349693,
          86.243386,
          62.941176
        ],
        "alpha": 1,
        "hex": "#f2894f"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 550: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          20.967742,
          86.111111,
          57.647059
        ],
        "alpha": 1,
        "hex": "#f07736"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Orange Ochre. Step 600: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          21.743119,
          86.507937,
          50.588235
        ],
        "alpha": 1,
        "hex": "#ee6314"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 650: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          20.510204,
          85.964912,
          44.705882
        ],
        "alpha": 1,
        "hex": "#d45310"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 700: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          19.772727,
          89.795918,
          38.431373
        ],
        "alpha": 1,
        "hex": "#ba440a"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 750: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          18.461538,
          93.975904,
          32.54902
        ],
        "alpha": 1,
        "hex": "#a13505"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Deep Orange. Step 800: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          16.764706,
          100,
          26.666667
        ],
        "alpha": 1,
        "hex": "#882600"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          14.285714,
          100,
          20.588235
        ],
        "alpha": 1,
        "hex": "#691900"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          10.263158,
          100,
          14.901961
        ],
        "alpha": 1,
        "hex": "#4c0d00"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          3.75,
          100,
          9.411765
        ],
        "alpha": 1,
        "hex": "#300300"
      }
    }
  },
  "nsw-aboriginal-brown": {
    "50": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          25.263158,
          76,
          95.098039
        ],
        "alpha": 1,
        "hex": "#fcf1e9"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          23.225806,
          63.265306,
          90.392157
        ],
        "alpha": 1,
        "hex": "#f6e3d7"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          23.72093,
          57.333333,
          85.294118
        ],
        "alpha": 1,
        "hex": "#efd5c4"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Macadamia Brown. Step 200: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          24,
          55.555556,
          80.588235
        ],
        "alpha": 1,
        "hex": "#e9c8b2"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 250: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          23.478261,
          56.097561,
          75.882353
        ],
        "alpha": 1,
        "hex": "#e4ba9f"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          24.146341,
          55.405405,
          70.980392
        ],
        "alpha": 1,
        "hex": "#dead8c"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          24.123711,
          56.069364,
          66.078431
        ],
        "alpha": 1,
        "hex": "#d99f78"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Claystone Brown. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          24,
          55.555556,
          61.176471
        ],
        "alpha": 1,
        "hex": "#d39165"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 450: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          22.363636,
          49.107143,
          56.078431
        ],
        "alpha": 1,
        "hex": "#c68158"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown — part of the NSW Government Aboriginal colour palette, which reflects the history of Aboriginal people within NSW, rich in diversity of culture, tribes, landscapes and history. Step 500: mid-tone.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          21.272727,
          44,
          50.980392
        ],
        "alpha": 1,
        "hex": "#b9724b"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 550: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          19.816514,
          46.781116,
          45.686275
        ],
        "alpha": 1,
        "hex": "#ab623e"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Firewood Brown. Step 600: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          18.333333,
          51.923077,
          40.784314
        ],
        "alpha": 1,
        "hex": "#9e5332"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 650: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          18.6,
          56.179775,
          34.901961
        ],
        "alpha": 1,
        "hex": "#8b4627"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 700: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          18.709677,
          62.416107,
          29.215686
        ],
        "alpha": 1,
        "hex": "#79391c"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 750: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          20,
          73.109244,
          23.333333
        ],
        "alpha": 1,
        "hex": "#672d10"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Riverbed Brown. Step 800: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          21,
          88.888889,
          17.647059
        ],
        "alpha": 1,
        "hex": "#552105"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          19.047619,
          94.029851,
          13.137255
        ],
        "alpha": 1,
        "hex": "#411602"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          16,
          100,
          8.823529
        ],
        "alpha": 1,
        "hex": "#2d0c00"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          8.888889,
          100,
          5.294118
        ],
        "alpha": 1,
        "hex": "#1b0400"
      }
    }
  },
  "nsw-aboriginal-yellow": {
    "50": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          49.411765,
          100,
          96.666667
        ],
        "alpha": 1,
        "hex": "#fffcee"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          46.451613,
          100,
          93.921569
        ],
        "alpha": 1,
        "hex": "#fff8e0"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          46.363636,
          100,
          91.372549
        ],
        "alpha": 1,
        "hex": "#fff5d3"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Sunbeam Yellow. Step 200: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          45.517241,
          100,
          88.627451
        ],
        "alpha": 1,
        "hex": "#fff1c5"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 250: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          45.833333,
          100,
          85.882353
        ],
        "alpha": 1,
        "hex": "#ffeeb7"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          46.046512,
          100,
          83.137255
        ],
        "alpha": 1,
        "hex": "#ffeba9"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          46.060606,
          98.019802,
          80.196078
        ],
        "alpha": 1,
        "hex": "#fee79b"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Golden Wattle Yellow. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          46.315789,
          98.275862,
          77.254902
        ],
        "alpha": 1,
        "hex": "#fee48c"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 450: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          42.481752,
          98.561151,
          72.745098
        ],
        "alpha": 1,
        "hex": "#fed675"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow — part of the NSW Government Aboriginal colour palette, which reflects the history of Aboriginal people within NSW, rich in diversity of culture, tribes, landscapes and history. Step 500: mid-tone.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          39.875776,
          98.773006,
          68.039216
        ],
        "alpha": 1,
        "hex": "#fec85d"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 550: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          37.741935,
          98.93617,
          63.137255
        ],
        "alpha": 1,
        "hex": "#feb944"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Sandstone Yellow. Step 600: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          36.27907,
          99.078341,
          57.45098
        ],
        "alpha": 1,
        "hex": "#fea927"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 650: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          37.538462,
          77.689243,
          49.215686
        ],
        "alpha": 1,
        "hex": "#df961c"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 700: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          38.742857,
          82.938389,
          41.372549
        ],
        "alpha": 1,
        "hex": "#c18312"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 750: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          39.873418,
          91.860465,
          33.72549
        ],
        "alpha": 1,
        "hex": "#a57007"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Bush Honey Yellow. Step 800: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          41.167883,
          100,
          26.862745
        ],
        "alpha": 1,
        "hex": "#895e00"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          40.571429,
          100,
          20.588235
        ],
        "alpha": 1,
        "hex": "#694700"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          37.894737,
          100,
          14.901961
        ],
        "alpha": 1,
        "hex": "#4c3000"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          35.744681,
          100,
          9.215686
        ],
        "alpha": 1,
        "hex": "#2f1c00"
      }
    }
  },
  "nsw-aboriginal-green": {
    "50": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          94.285714,
          36.842105,
          96.27451
        ],
        "alpha": 1,
        "hex": "#f5f9f2"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          95,
          33.333333,
          92.941176
        ],
        "alpha": 1,
        "hex": "#ecf3e7"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          93.75,
          29.62963,
          89.411765
        ],
        "alpha": 1,
        "hex": "#e3ecdc"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Saltbush Green. Step 200: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          94.285714,
          29.577465,
          86.078431
        ],
        "alpha": 1,
        "hex": "#dae6d1"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 250: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          94.615385,
          29.545455,
          82.745098
        ],
        "alpha": 1,
        "hex": "#d1e0c6"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          94.83871,
          28.971963,
          79.019608
        ],
        "alpha": 1,
        "hex": "#c7d9ba"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          95,
          29.032258,
          75.686275
        ],
        "alpha": 1,
        "hex": "#bed3af"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Gumleaf Green. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          95.121951,
          29.078014,
          72.352941
        ],
        "alpha": 1,
        "hex": "#b5cda4"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 450: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          93.461538,
          29.885057,
          65.882353
        ],
        "alpha": 1,
        "hex": "#a5c28e"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green — part of the NSW Government Aboriginal colour palette, which reflects the history of Aboriginal people within NSW, rich in diversity of culture, tribes, landscapes and history. Step 500: mid-tone.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          91.875,
          30.769231,
          59.215686
        ],
        "alpha": 1,
        "hex": "#95b777"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 550: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          90,
          31.404959,
          52.54902
        ],
        "alpha": 1,
        "hex": "#86ac60"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Marshland Lime. Step 600: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          87.032967,
          39.393939,
          45.294118
        ],
        "alpha": 1,
        "hex": "#78a146"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 650: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          98.4,
          35.545024,
          41.372549
        ],
        "alpha": 1,
        "hex": "#5f8f44"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 700: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          111.147541,
          32.275132,
          37.058824
        ],
        "alpha": 1,
        "hex": "#497d40"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 750: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          127.777778,
          34.177215,
          30.980392
        ],
        "alpha": 1,
        "hex": "#346a3b"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Bushland Green. Step 800: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          140.727273,
          45.454545,
          23.72549
        ],
        "alpha": 1,
        "hex": "#215834"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          141.333333,
          51.724138,
          17.058824
        ],
        "alpha": 1,
        "hex": "#154225"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          141.666667,
          64.285714,
          10.980392
        ],
        "alpha": 1,
        "hex": "#0a2e17"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          139.2,
          86.206897,
          5.686275
        ],
        "alpha": 1,
        "hex": "#021b0a"
      }
    }
  },
  "nsw-aboriginal-blue": {
    "50": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          190,
          54.545455,
          95.686275
        ],
        "alpha": 1,
        "hex": "#eef8fa"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          188.571429,
          48.837209,
          91.568627
        ],
        "alpha": 1,
        "hex": "#dff1f4"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          190,
          46.875,
          87.45098
        ],
        "alpha": 1,
        "hex": "#d0e9ee"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Coastal Blue. Step 200: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          189.230769,
          45.882353,
          83.333333
        ],
        "alpha": 1,
        "hex": "#c1e2e8"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 250: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          188.75,
          45.283019,
          79.215686
        ],
        "alpha": 1,
        "hex": "#b2dbe2"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          188.421053,
          44.88189,
          75.098039
        ],
        "alpha": 1,
        "hex": "#a3d4dc"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          189.850746,
          45.578231,
          71.176471
        ],
        "alpha": 1,
        "hex": "#94ccd7"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Light Water Blue. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          189.350649,
          45.56213,
          66.862745
        ],
        "alpha": 1,
        "hex": "#84c5d1"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 450: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          192.134831,
          41.395349,
          57.843137
        ],
        "alpha": 1,
        "hex": "#67aec0"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue — part of the NSW Government Aboriginal colour palette, which reflects the history of Aboriginal people within NSW, rich in diversity of culture, tribes, landscapes and history. Step 500: mid-tone.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          195.294118,
          40.8,
          49.019608
        ],
        "alpha": 1,
        "hex": "#4a96b0"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 550: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          197.73913,
          55.555556,
          40.588235
        ],
        "alpha": 1,
        "hex": "#2e7fa1"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Saltwater Blue. Step 600: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          199.090909,
          83.544304,
          30.980392
        ],
        "alpha": 1,
        "hex": "#0d6791"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 650: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          199.02439,
          87.234043,
          27.647059
        ],
        "alpha": 1,
        "hex": "#095d84"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 700: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          198.947368,
          91.935484,
          24.313725
        ],
        "alpha": 1,
        "hex": "#055377"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 750: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          199.038462,
          96.296296,
          21.176471
        ],
        "alpha": 1,
        "hex": "#02496a"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Billabong Blue. Step 800: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          199.148936,
          100,
          18.431373
        ],
        "alpha": 1,
        "hex": "#00405e"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          200.833333,
          100,
          14.117647
        ],
        "alpha": 1,
        "hex": "#002f48"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          202.352941,
          100,
          10
        ],
        "alpha": 1,
        "hex": "#002033"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          207.096774,
          100,
          6.078431
        ],
        "alpha": 1,
        "hex": "#00111f"
      }
    }
  },
  "nsw-aboriginal-purple": {
    "50": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          313.333333,
          47.368421,
          96.27451
        ],
        "alpha": 1,
        "hex": "#faf1f8"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          309.230769,
          33.333333,
          92.352941
        ],
        "alpha": 1,
        "hex": "#f2e5f0"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          309.473684,
          32.20339,
          88.431373
        ],
        "alpha": 1,
        "hex": "#ebd8e8"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Dusk Purple. Step 200: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          310,
          30.769231,
          84.705882
        ],
        "alpha": 1,
        "hex": "#e4cce0"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 250: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          310,
          30.612245,
          80.784314
        ],
        "alpha": 1,
        "hex": "#ddbfd8"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          310,
          31.034483,
          77.254902
        ],
        "alpha": 1,
        "hex": "#d7b3d1"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          310,
          30.882353,
          73.333333
        ],
        "alpha": 1,
        "hex": "#d0a6c9"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Lilli Pilli Purple. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          308.93617,
          30.322581,
          69.607843
        ],
        "alpha": 1,
        "hex": "#c99ac2"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 450: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          308.4,
          27.472527,
          64.313725
        ],
        "alpha": 1,
        "hex": "#bd8bb6"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple — part of the NSW Government Aboriginal colour palette, which reflects the history of Aboriginal people within NSW, rich in diversity of culture, tribes, landscapes and history. Step 500: mid-tone.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          307.924528,
          25.358852,
          59.019608
        ],
        "alpha": 1,
        "hex": "#b17caa"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 550: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          307.368421,
          24.255319,
          53.921569
        ],
        "alpha": 1,
        "hex": "#a66d9f"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Spirit Lilac. Step 600: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          307,
          24.193548,
          48.627451
        ],
        "alpha": 1,
        "hex": "#9a5e93"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 650: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          306.792453,
          25.118483,
          41.372549
        ],
        "alpha": 1,
        "hex": "#844f7e"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 700: borders and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          307.826087,
          26.136364,
          34.509804
        ],
        "alpha": 1,
        "hex": "#6f4169"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 750: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          309,
          28.169014,
          27.843137
        ],
        "alpha": 1,
        "hex": "#5b3355"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Bush Plum. Step 800: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          309.090909,
          30.275229,
          21.372549
        ],
        "alpha": 1,
        "hex": "#472642"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          308.888889,
          34.177215,
          15.490196
        ],
        "alpha": 1,
        "hex": "#351a31"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          309,
          38.461538,
          10.196078
        ],
        "alpha": 1,
        "hex": "#241021"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          312,
          55.555556,
          5.294118
        ],
        "alpha": 1,
        "hex": "#150612"
      }
    }
  },
  "success": {
    "50": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          110,
          50,
          95.294118
        ],
        "alpha": 1,
        "hex": "#eff9ed"
      }
    },
    "100": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          114.285714,
          46.666667,
          91.176471
        ],
        "alpha": 1,
        "hex": "#e0f3de"
      }
    },
    "150": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          113.793103,
          43.283582,
          86.862745
        ],
        "alpha": 1,
        "hex": "#d2eccf"
      }
    },
    "200": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          113.513514,
          41.573034,
          82.54902
        ],
        "alpha": 1,
        "hex": "#c4e5c0"
      }
    },
    "250": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          113.877551,
          37.40458,
          74.313725
        ],
        "alpha": 1,
        "hex": "#aad6a5"
      }
    },
    "300": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          115.081967,
          35.260116,
          66.078431
        ],
        "alpha": 1,
        "hex": "#8fc78a"
      }
    },
    "350": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          115.833333,
          33.333333,
          57.647059
        ],
        "alpha": 1,
        "hex": "#74b76f"
      }
    },
    "400": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          117.142857,
          33.333333,
          49.411765
        ],
        "alpha": 1,
        "hex": "#58a854"
      }
    },
    "450": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          118.021978,
          39.393939,
          45.294118
        ],
        "alpha": 1,
        "hex": "#49a146"
      }
    },
    "500": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          118.181818,
          47.826087,
          40.588235
        ],
        "alpha": 1,
        "hex": "#399936"
      }
    },
    "550": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          119.454545,
          60.43956,
          35.686275
        ],
        "alpha": 1,
        "hex": "#259224"
      }
    },
    "600": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          123.043478,
          100,
          27.058824
        ],
        "alpha": 1,
        "hex": "#008a07"
      }
    },
    "650": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          122.105263,
          100,
          22.352941
        ],
        "alpha": 1,
        "hex": "#007204"
      }
    },
    "700": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          121.333333,
          100,
          17.647059
        ],
        "alpha": 1,
        "hex": "#005a02"
      }
    },
    "750": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          120.882353,
          100,
          13.333333
        ],
        "alpha": 1,
        "hex": "#004401"
      }
    },
    "800": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          120,
          100,
          9.215686
        ],
        "alpha": 1,
        "hex": "#002f00"
      }
    },
    "850": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          120,
          100,
          6.666667
        ],
        "alpha": 1,
        "hex": "#002200"
      }
    },
    "900": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          120,
          100,
          4.313725
        ],
        "alpha": 1,
        "hex": "#001600"
      }
    },
    "950": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          120,
          100,
          2.156863
        ],
        "alpha": 1,
        "hex": "#000b00"
      }
    }
  },
  "warning": {
    "50": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          20,
          100,
          96.470588
        ],
        "alpha": 1,
        "hex": "#fff3ed"
      }
    },
    "100": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          18.181818,
          100,
          93.529412
        ],
        "alpha": 1,
        "hex": "#ffe8de"
      }
    },
    "150": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          17.5,
          100,
          90.588235
        ],
        "alpha": 1,
        "hex": "#ffddcf"
      }
    },
    "200": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          17.704918,
          93.846154,
          87.254902
        ],
        "alpha": 1,
        "hex": "#fdd2c0"
      }
    },
    "250": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          17.777778,
          81.818182,
          80.588235
        ],
        "alpha": 1,
        "hex": "#f6bda5"
      }
    },
    "300": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          18,
          74.626866,
          73.72549
        ],
        "alpha": 1,
        "hex": "#eea88a"
      }
    },
    "350": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          18.151261,
          70.414201,
          66.862745
        ],
        "alpha": 1,
        "hex": "#e6936f"
      }
    },
    "400": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          18.26087,
          66.990291,
          59.607843
        ],
        "alpha": 1,
        "hex": "#dd7d53"
      }
    },
    "450": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          18.648649,
          65.486726,
          55.686275
        ],
        "alpha": 1,
        "hex": "#d87244"
      }
    },
    "500": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          19.245283,
          64.37247,
          51.568627
        ],
        "alpha": 1,
        "hex": "#d36734"
      }
    },
    "550": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          20.462428,
          72.384937,
          46.862745
        ],
        "alpha": 1,
        "hex": "#ce5c21"
      }
    },
    "600": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          23.880597,
          100,
          39.411765
        ],
        "alpha": 1,
        "hex": "#c95000"
      }
    },
    "650": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          21.818182,
          96.491228,
          33.529412
        ],
        "alpha": 1,
        "hex": "#a83f03"
      }
    },
    "700": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          19.849624,
          95.683453,
          27.254902
        ],
        "alpha": 1,
        "hex": "#882f03"
      }
    },
    "750": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          17.884615,
          98.113208,
          20.784314
        ],
        "alpha": 1,
        "hex": "#692001"
      }
    },
    "800": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          14.4,
          100,
          14.705882
        ],
        "alpha": 1,
        "hex": "#4b1200"
      }
    },
    "850": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          10.526316,
          100,
          11.176471
        ],
        "alpha": 1,
        "hex": "#390a00"
      }
    },
    "900": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          6.153846,
          100,
          7.647059
        ],
        "alpha": 1,
        "hex": "#270400"
      }
    },
    "950": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          2.608696,
          100,
          4.509804
        ],
        "alpha": 1,
        "hex": "#170100"
      }
    }
  },
  "danger": {
    "50": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          3.75,
          100,
          96.862745
        ],
        "alpha": 1,
        "hex": "#fff0ef"
      }
    },
    "100": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          2,
          100,
          94.117647
        ],
        "alpha": 1,
        "hex": "#ffe2e1"
      }
    },
    "150": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          0,
          100,
          91.568627
        ],
        "alpha": 1,
        "hex": "#ffd4d4"
      }
    },
    "200": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          0,
          93.220339,
          88.431373
        ],
        "alpha": 1,
        "hex": "#fdc6c6"
      }
    },
    "250": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          359.166667,
          76.595745,
          81.568627
        ],
        "alpha": 1,
        "hex": "#f4acad"
      }
    },
    "300": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          358.636364,
          67.692308,
          74.509804
        ],
        "alpha": 1,
        "hex": "#ea9294"
      }
    },
    "350": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          357.669903,
          61.676647,
          67.254902
        ],
        "alpha": 1,
        "hex": "#df787c"
      }
    },
    "400": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          355.932203,
          57.281553,
          59.607843
        ],
        "alpha": 1,
        "hex": "#d35d65"
      }
    },
    "450": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          354.80315,
          55.947137,
          55.490196
        ],
        "alpha": 1,
        "hex": "#cd4e59"
      }
    },
    "500": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          353.333333,
          54.216867,
          51.176471
        ],
        "alpha": 1,
        "hex": "#c63f4e"
      }
    },
    "550": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          351.020408,
          62.553191,
          46.078431
        ],
        "alpha": 1,
        "hex": "#bf2c42"
      }
    },
    "600": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          346.626506,
          82.178218,
          39.607843
        ],
        "alpha": 1,
        "hex": "#b81237"
      }
    },
    "650": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          346.901408,
          86.585366,
          32.156863
        ],
        "alpha": 1,
        "hex": "#990b2a"
      }
    },
    "700": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          347.288136,
          90.769231,
          25.490196
        ],
        "alpha": 1,
        "hex": "#7c061f"
      }
    },
    "750": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          348.387097,
          95.876289,
          19.019608
        ],
        "alpha": 1,
        "hex": "#5f0214"
      }
    },
    "800": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          351.176471,
          100,
          13.333333
        ],
        "alpha": 1,
        "hex": "#44000a"
      }
    },
    "850": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          354.117647,
          100,
          10
        ],
        "alpha": 1,
        "hex": "#330005"
      }
    },
    "900": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          356.571429,
          100,
          6.862745
        ],
        "alpha": 1,
        "hex": "#230002"
      }
    },
    "950": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          357,
          100,
          3.921569
        ],
        "alpha": 1,
        "hex": "#140001"
      }
    }
  },
  "info": {
    "50": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          218.571429,
          46.666667,
          94.117647
        ],
        "alpha": 1,
        "hex": "#e9eef7"
      }
    },
    "100": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          216.521739,
          36.507937,
          87.647059
        ],
        "alpha": 1,
        "hex": "#d4ddeb"
      }
    },
    "150": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          217.5,
          34.042553,
          81.568627
        ],
        "alpha": 1,
        "hex": "#c0cce0"
      }
    },
    "200": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          218.04878,
          32.8,
          75.490196
        ],
        "alpha": 1,
        "hex": "#acbbd5"
      }
    },
    "250": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          218.888889,
          34.615385,
          69.411765
        ],
        "alpha": 1,
        "hex": "#96a9cc"
      }
    },
    "300": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          218.181818,
          35.106383,
          63.137255
        ],
        "alpha": 1,
        "hex": "#8098c2"
      }
    },
    "350": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          218.961039,
          35.159817,
          57.058824
        ],
        "alpha": 1,
        "hex": "#6b86b8"
      }
    },
    "400": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          219.310345,
          34.939759,
          51.176471
        ],
        "alpha": 1,
        "hex": "#5775ae"
      }
    },
    "450": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          219.782609,
          37.398374,
          48.235294
        ],
        "alpha": 1,
        "hex": "#4d6ca9"
      }
    },
    "500": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          219.183673,
          42.608696,
          45.098039
        ],
        "alpha": 1,
        "hex": "#4264a4"
      }
    },
    "550": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          219.411765,
          47.663551,
          41.960784
        ],
        "alpha": 1,
        "hex": "#385b9e"
      }
    },
    "600": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          219.813084,
          53.768844,
          39.019608
        ],
        "alpha": 1,
        "hex": "#2e5299"
      }
    },
    "650": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          219.782609,
          56.790123,
          31.764706
        ],
        "alpha": 1,
        "hex": "#23427f"
      }
    },
    "700": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          219.74026,
          60.629921,
          24.901961
        ],
        "alpha": 1,
        "hex": "#193366"
      }
    },
    "750": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          220,
          66.315789,
          18.627451
        ],
        "alpha": 1,
        "hex": "#10254f"
      }
    },
    "800": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          220.408163,
          77.777778,
          12.352941
        ],
        "alpha": 1,
        "hex": "#071738"
      }
    },
    "850": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          222.631579,
          82.608696,
          9.019608
        ],
        "alpha": 1,
        "hex": "#040f2a"
      }
    },
    "900": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          228.461538,
          86.666667,
          5.882353
        ],
        "alpha": 1,
        "hex": "#02071c"
      }
    },
    "950": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          228,
          100,
          2.941176
        ],
        "alpha": 1,
        "hex": "#00030f"
      }
    }
  },
  "white": {
    "$type": "color",
    "$description": "Pure white — page backgrounds, content surfaces, and text on dark or solid fills.",
    "$value": {
      "colorSpace": "hsl",
      "components": [
        "none",
        0,
        100
      ],
      "alpha": 1,
      "hex": "#ffffff"
    }
  },
  "black": {
    "$type": "color",
    "$description": "Pure black — maximum-contrast text, overlays, and scrims.",
    "$value": {
      "colorSpace": "hsl",
      "components": [
        "none",
        0,
        0
      ],
      "alpha": 1,
      "hex": "#000000"
    }
  }
}
